export default __webpack_public_path__ + "navigation-examples-beta-query-parameters-960-00666e001dc149a209f5f512ba522c0b.png";